define.alias("shared/errors/credentials", "calendar/errors/credentials");